export default __webpack_public_path__ + "static/media/MoveToCapa.3b7a6dbd.png";